import {
  default as ClassicEditor,
  default as ClassicEditor2,
} from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const SuperstarEditMarketPlaceForm = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [convertedContent, setConvertedContent] = useState(null);
  const [convertedContent2, setConvertedContent2] = useState(null);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setConvertedContent("");
    setConvertedContent2("");
  }, []);

  const [title, setTitle] = useState("");
  const [unit_price, setUnitPrice] = useState("");
  const [total_items, setTotalItems] = useState("");
  const [keywords, setKeywords] = useState("");
  const [sellingItems, setSellingItems] = useState("");
  const [image, setImage] = useState();
  const [tax, setTax] = useState("");
  const [terms_conditions, setTermsConditions] = useState("");
  const [description, setDescription] = useState("");
  const [errorList, setErrorList] = useState([]);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'marketplace/images',delKey);


  useEffect(() => {
    axios.get(`/api/star/marketplace/product-edit/${id}`).then((res) => {
      if (res.data.status === 200) {
        setTitle(res.data.editData.title);
        setUnitPrice(res.data.editData.unit_price);
        setTotalItems(res.data.editData.total_items);
        setFilePath(res.data.editData.image);
        setTermsConditions(res.data.editData.terms_conditions);
        setTax(res.data.editData.tax);
        setKeywords(res.data.editData.keywords);
        setSellingItems(res.data.editData.total_selling);
        setDescription(res.data.editData.description);
      }
    });
  }, []);

  const handleOnChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }

  const storeStarMarketplace = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", convertedContent);
    formData.append("unit_price", unit_price);
    formData.append("terms_conditions", convertedContent2);
    formData.append("tax", tax);
    formData.append("total_items", total_items);
    formData.append("sellingItems", sellingItems);
    formData.append("keywords", keywords);
    if (image !== null) {
      formData.append("image", fileKey?fileKey:filePath);
    }


    axios
      .post(`/api/star/marketplace/product-store/${id}`, formData)

      .then((res) => {
        setLoading(false);
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          swal("Welcome", res.data.message, "success");
          history.push("/superstar/product-list/pending");
        }
      });
  };

  return (
    <div className="AS">
      <div className="text-light mb-3 d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={storeStarMarketplace}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Title</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={title}
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Keyword</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={keywords}
                        onChange={(event) => {
                          setKeywords(event.target.value);
                        }}
                      />
                      <span className="text-danger">{errorList.keywords}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={description}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Terms & Conditions</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor2}
                        data={terms_conditions}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent2(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.terms_conditions}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text">
                          <p>
                            <>Total Units</>
                          </p>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            className="form-control reply-control"
                            value={total_items}
                            min={0}
                            onChange={(event) => {
                              setTotalItems(event.target.value);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.total_items}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text text-md-end">
                          <p className="ms-4">
                            <>Price</>
                          </p>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            min={0}
                            step=".01"
                            className="form-control reply-control"
                            value={unit_price}
                            onChange={(event) => {
                              setUnitPrice(event.target.value);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.unit_price}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text text-md-start">
                          <p className="ms-4">
                            <>Tax</>
                          </p>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            min={0}
                            className="form-control reply-control"
                            value={tax}
                            onChange={(event) => {
                              setTax(event.target.value);
                            }}
                          />
                          {/* <input type="number" className="form-control input-gray" /> */}
                          <span className="text-danger">{errorList.tax}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Total Selling Items</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        min={0}
                        value={sellingItems}
                        onChange={(event) => {
                          setSellingItems(event.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Image</>
                      </p>
                    </div>
                    <div className="col-md-9">
                    {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        onChange={(e) => handleOnChange(e.target.files)}
                        id="image"
                        name="image"
                        accept="image/*"
                        ref={fileInputRef}
                      />

                {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}

                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {/* <Link to={`/superstar/post/${params.id}`}>
                        <button className="btn btnGoBack fw-bold" type="submit">
                          Go Back
                        </button>
                      </Link> */}
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperstarEditMarketPlaceForm;
